
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import 'react';
import { maskContainer } from './styles.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';
import { m } from '../../../../node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs.js';

var maskVariants = {
  hidden: {
    opacity: 0
  },
  expanded: {
    opacity: 1
  }
};
var Mask = function Mask(_ref) {
  var onClose = _ref.onClose;
  return jsx(m.div, {
    css: maskContainer,
    onClick: onClose,
    initial: "hidden",
    animate: "expanded",
    exit: "hidden",
    variants: maskVariants,
    "data-testid": "mask"
  });
};

export { Mask as default };
//# sourceMappingURL=Mask.js.map
